import * as Yup from 'yup'

const schema = Yup.object().shape({
  month: Yup.string().required('Mês obrigatório!'),
  year: Yup.string().required('Ano obrigatório!'),
})

export default schema
